import { Archivo } from "./archivo";

export class EntregaUnidad {
    idEntregaUnidad: number;
    idOrdenServicio: number;
    status: string;
    fechaEntrega: Date;
    idEmpleado: number;
    finiquito: boolean;
    encuesta: boolean;
    deducible: boolean;
    demerito: boolean;
    identificacion: boolean;
    observaciones: string;
    public idFiniquito: number;
    public idEncuesta: number;
    public idIdentificacion: number;
    public idDeducible: number;
    public idDemerito: number;
}

export class FacturacionEntrega {
    tipoFactura: string;
    archivo: Archivo;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/entregaUnidad.ts